<!-- 忘记密码面板 -->
<template>
  <div class="forgetpassword-wrapper">
    <div class="forgetpassword">
      <div class="project">
        <zws-image width="42px" height="42px" :src="data.projectLogo"></zws-image>
        <zws-text :text="data.projectName" :color="data.loginTextColor" fontSize="28px" marginLeft="10px"></zws-text>
      </div>
      <el-form ref="form" :model="form"  :rules="rules" label-width="80px">
        <el-form-item :label="data.usernameLabel" prop="username">
          <el-input v-model="form.username" :placeholder="data.usernamePlaceholder"></el-input>
        </el-form-item>
        <el-form-item :label="data.passwordLabel" prop="password">
          <el-input type="password" v-model="form.password" :placeholder="data.passwordPlaceholder"></el-input>
        </el-form-item>
        <el-form-item :label="data.confirmPasswordLabel" prop="confirmPassword">
          <el-input type="password" v-model="form.confirmPassword" :placeholder="data.confirmPasswordPlaceholder"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="data.codeLabel" prop="code">
          <div class="getCode-wrapper">
            <div class="smscodeBox">
              <el-input v-model="form.code" :placeholder="data.codePlaceholder"></el-input>
            </div>
            <div class="getSmscodeBtn">
              <count-down @count='getCountFlag' :validateFlag="isExistUsername" @onClickSmsCode="onClickSmsCode">
              </count-down>
            </div>
          </div>
        </el-form-item> -->
      </el-form>
      <div class="button-wrapper">
        <el-button class="button" type="primary" @click="onClickOk('form')">确定</el-button>
        <p class="login-tips">点击这里，返回
          <el-button type="text" class="login-tips-text" @click="returnToLogin">登录</el-button>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import CountDown from '../../../Common/ZWSComponent/CountDown.vue'
import validate from '../../../Common/ZWSUtils/validate.js'
import zwsText from '../../../Common/ZWSComponent/Text.vue'
import zwsImage from '../../../Common/ZWSComponent/Image.vue'
export default {
  components: {
    zwsText,
    zwsImage,
    CountDown
  },
  props: {
    propsList: {
      type: Object
    },
    isExistUsername: {
      type: Boolean
    }
  },
  data () {
    return {
      data: {
        projectLogo: require('../../../Resource/Image/logo.png'),
        projectName: '项目名',
        projectThemeColor: '',
        loginTextColor: '#ffffff',
        usernameLabel: '用户名',
        usernamePlaceholder: '请输入用户名或手机号',
        passwordLabel: '密码',
        passwordPlaceholder: '请输入密码',
        confirmPasswordLabel: '确认密码',
        confirmPasswordPlaceholder: '请输入确认密码',
        mobileLabel: '手机号码',
        mobilePlaceholder: '请输入手机号码',
        codeLabel: '验证码',
        codePlaceholder: '请输入验证码'
      },
      form: {
        username: '',
        password: '',
        confirmPassword: ''
      },
      rules: {
        username: [
          { required: true, validator: this.checkUsername, trigger: 'blur' }
        ],
        password: [
          { required: true, validator: this.checkPassword, trigger: 'blur' }
        ],
        confirmPassword: [
          {
            required: true,
            validator: this.checkConfirmPassword,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    returnToLogin () {
      this.$emit('returnToLogin')
    },
    checkUsername (rule, value, callback) {
      if (value === '') {
        return callback(new Error(this.$t('userTips.username.empty')))
      }
      const result = validate.isSupplierCode(value)
      callback(
        result ? undefined : new Error(this.$t('userTips.password.error'))
      )
    },
    checkPassword (rule, value, callback) {
      const result = validate.isPassword(value)
      callback(
        result ? undefined : new Error(this.$t('userTips.password.error'))
      )
    },
    checkConfirmPassword (rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入确认密码'))
      }
      const result = value === this.form.password
      callback(
        result
          ? undefined
          : new Error('两次密码不一致，请确认密码是否输入错误')
      )
    },
    checkCode (rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入验证码'))
      }
      const result = validate.isVerifyCode(value)
      callback(
        result ? undefined : new Error('不是有效的验证码')
      )
    },
    getCountFlag (val) {
      if (val) {
        this.$emit('sendSmsCode', {
          username: this.form.username,
          countFlag: true
        })
      }
    },
    onClickSmsCode () {
      this.$emit('onIsExistUsername', this.form.username)
    },
    onClickOk (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$emit('resetPassword', this.form)
        }
      })
    }
  }
}
</script>

<style>
</style>

<style lang='less' scoped>
.forgetpassword-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  .forgetpassword {
    width: 400px;
    padding: 30px;
    background-color: #304156;
    box-sizing: border-box;
    .project {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;
    }
    .el-form {
      // padding: 30px;
      color: #ffffff;
      // .el-input {
      //   width: 214px;
      //   height: 36px;
      // }
      .getCode-wrapper {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        .smscodeBox {
          // width: 115px;
          margin-right: 5px;
          .el-input {
            // width: 115px;
          }
        }
        .getSmscodeBtn {
          float: none;
          display: inline-block;
        }
      }
    }
  }
  .button-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    // justify-content: center;
    // align-items: center;
    margin-top: 10px;
    .button {
      // 330-70
      width: 260px;
    }
    .login-tips {
      font-size: 14px;
      margin-top: 10px;
      color: #ffffff;
      // .login-tips-text {
      //   color: #5ec4ff;
      // }
    }
  }
}
</style>



// WEBPACK FOOTER //
// third_party/common_app/LoginModule/View/Ctrl/ForgetPasswordCtrl.vue